<template>
  <c-base-dialog v-model="isShow" :option="option" @close="$emit('gift:package:close')">
    <template slot="body">
      <div :class="['gift-record-dialog', 'gift-record-dialog--default', !isMobile ? 'gift-record-dialog--pc' : '']">
        <!--        <p class="gift-record-dialog-title-name">获奖记录</p>-->
        <div class="gift-record-dialog-content" ref="giftRecordDialogContent" :style="{ color: fontColor }">
          <template v-if="list.length > 0">
            <div class="gift-record-item" v-for="(item) in list" :key="item.id">
              <div class="gift-record-item-date">
                {{ item.gift_time }}
              </div>
              <div class="gift-record-item-name" :style="{ backgroundColor: recordBackgroundColor }">
                <span class="gift-record-gift-name">{{ item.gift_name }}</span>
                <template v-if="checkIsSurvey(item.gift_id)">
                  <a class="gift-record-action-link"
                    @click="actionByType(item.gift_id, 'privateQualification')">填写调查问卷</a>
                </template>
                <template v-else-if="checkIsMatchGift(item.gift_id, 'packageRealGift')">
                  <a class="gift-record-action-link" @click="$emit('gift-record-fill-address')">填写收货地址</a>
                </template>
                <template v-else-if="checkIsMatchGift(item.gift_id, 'cash')">
                  <a class="gift-record-action-link" @click="$emit('gift:package:reward:record:event:wx-fill')">绑定微信</a>
                </template>
                <template v-else>
                  <a v-if="item.package_real_flag === '1'" class="gift-record-action-link"
                    @click="$emit('gift-record-fill-address')">填写收货地址</a>
                  <a v-else-if="item.package_cdkey" class="gift-record-action-link"
                    @click="copyText(item.package_cdkey)">复制CDKEY</a>
                  <a v-else-if="item.gift_name.length > 12" class="gift-record-action-link"
                    @click="showDetail(item.gift_name)">详情</a>
                </template>
              </div>
            </div>
          </template>

          <template v-if="list.length === 0">
            <!--  空状态            -->
            <div class="gift-record-empty-status-area">
              <img class="gift-record-empty-status-img"
                src="https://game.gtimg.cn/images/js/img/tgclub/emptyImageStatus.png" alt="">
              <p class="gift-record-empty-status-text">暂无获奖记录</p>
            </div>

          </template>
        </div>

      </div>
    </template>
  </c-base-dialog>
</template>

<script>
import { ClaimRecord } from '../apis';
import CDialog from '../base-dialog';
import Vue from 'vue';
import { common } from '../../../index';

export default {
  name: 'gift-reward-record',
  components: {
    [CDialog.name]: CDialog,
  },
  props: {
    gameCode: String,
    params: Object,
    backgroundImage: String,
    hidePackageIds: Array,
    fontColor: {
      type: String,
      default: '#000',
    },
    recordBackgroundColor: {
      type: String,
      default: 'rgba(247,249,250,1)',
    },
    option: Object,
    pageSize: Number,
  },
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      list: [],
      page: {
        current: 1,
        total: 0,
      },

      isShow: true,
      isEnd: false,
      isRefreshBool: false,
    };
  },
  watch: {
    'page.current'() {
      this.freshList();
    },
  },
  async mounted() {
    this.freshList();
    this.$nextTick(() => {
      common.tool?.listenElementScrollEvent(this.$refs.giftRecordDialogContent, this.handleScrollEvent);
    });
  },
  beforeDestroy() {
    common.tool?.removeElementScrollEvent(this.$refs.giftRecordDialogContent, this.handleScrollEvent);
  },
  methods: {
    getConfigFromActInfo(giftId, type) {
      const receiveGiftCustomConfig = Vue.prototype?.$actInfo?.extendConfig?.receiveGiftCustomConfig ?? [];
      const record = receiveGiftCustomConfig?.find(item => parseInt(item.gift_id, 10)
        === parseInt(giftId, 10) && item.type === type);
      return record;
    },
    // 优先判断
    checkIsSurvey(giftId) {
      const id = parseInt(giftId, 10);
      if (!id) return false;
      const record = this.getConfigFromActInfo(giftId, 'privateQualification');
      if (record) {
        return true;
      }
      return false;
    },
    // 优先匹配个性化礼包类型
    checkIsMatchGift(giftId, type) {
      const id = parseInt(giftId, 10);
      if (!id) return false;
      const record = this.getConfigFromActInfo(giftId, type);
      if (record) {
        return true;
      }
      return false;
    },
    actionByType(giftId, type) {
      if (!type) {
        return;
      }
      const record = this.getConfigFromActInfo(giftId, type);
      if (!record) {
        return;
      }
      switch (type) {
        case 'privateQualification': {
          const { link = '' } = record?.playload ?? {};
          if (link) {
            window.location.href = link;
          }
        }
          break;
      }
    },
    async freshList() {
      if (this.$isInEditor) {
        this.list = new Array(this.pageSize).fill({
          gift_time: '2021-10-21 12:00:00',
          gift_name: '元宝x3',
          show_gift_name: '元宝x3',
          package_real_flag: '1',
        });
        this.page.total = 11;
        return;
      }
      const bushandang = Vue.prototype?.$actInfo?.extendConfig?.bushandang || false;
      // 防止多次触发
      if (this.isRefreshBool === true) {
        return false;
      }
      this.isRefreshBool = true;
      let tempList = [];
      ({ records: tempList, total: this.page.total } = await ClaimRecord.getClaimRecords({
        game_code: bushandang ? '' : this.gameCode,
        ...this.params,
        page_size: this.pageSize,
        page_index: this.page.current,
      }));
      this.list.push(...tempList);
      if (this.hidePackageIds) {
        this.list = this.list.filter(i => !~this.hidePackageIds.indexOf(i.gift_id));
      }
      this.list = this.list.map((i) => {
        const item = i;
        // 处理gift_id
        const giftIds = item.gift_id.split(',');
        const giftNames = item.gift_name.split(',');
        const newGiftNames = [];
        for (let i = 0; i < giftIds.length; i++) {
          const giftItems = giftIds[i].split(':');
          if (giftItems.length === 2 && giftItems[1] > '1') {
            newGiftNames.push(`${giftNames[i]} ${giftItems[1]}个`);
          } else {
            newGiftNames.push(giftNames[i]);
          }
        }
        item.show_gift_name = newGiftNames.join(',');
        if (item.show_gift_name.length > 10) item.show_gift_name = item.show_gift_name.substr(0, 10);
        return item;
      });
      this.isRefreshBool = false;
    },
    showDetail(giftName) {
      this.alert(giftName);
    },
    copyText(content) {
      try {
        const isRTL = document.documentElement.getAttribute('dir') === 'rtl';

        const textarea = document.createElement('textarea');
        // Prevent zooming on iOS
        textarea.style.fontSize = '12pt';
        // Reset box model
        textarea.style.border = '0';
        textarea.style.padding = '0';
        textarea.style.margin = '0';
        // Move element out of screen horizontally
        textarea.style.position = 'absolute';
        textarea.style[isRTL ? 'right' : 'left'] = '-9999px';
        // Move element to the same position vertically
        const yPosition = window.pageYOffset || document.documentElement.scrollTop;
        textarea.style.top = `${yPosition}px`;

        textarea.setAttribute('readonly', '');

        // 赋值
        textarea.value = content;
        document.body.appendChild(textarea);
        // 选中
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
        // 复制
        let succeeded;
        try {
          succeeded = document.execCommand('copy');
        } catch (err) {
          succeeded = false;
        }
        // 移除输入框
        document.body.removeChild(textarea);
        this.alert(`复制${succeeded ? '成功' : '失败'}`);
      } catch (e) {
      }
    },
    handleScrollEvent() {
      if (common.tool?.checkIsScrollEnd(this.$refs.giftRecordDialogContent) === false) {
        return false;
      }
      if (this.page.current < (this.page.total / this.pageSize) && this.isRefreshBool === false) {
        this.page.current = this.page.current + 1;
      }
    },
  },
};
</script>

<style scoped>
.modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 100;
}

.gift-record-dialog {
  font-size: 0.2rem;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}

.gift-record-dialog-content {
  padding: 0 0.5rem;
  text-align: center;
  margin-top: 0.2rem;
  overflow-y: auto;
  overflow-x: hidden;
  height: 5.5rem;
  max-height: 5.5rem;
}


.gift-record-dialog-title-name {
  /*color: #242424;*/
  font-size: 0.32rem;
  font-weight: 500;
  padding: 0 0.5rem;
}

.gift-record-item {
  background: rgba(247, 249, 250, 1);
  border-radius: 0.1rem;
  margin-bottom: 0.3rem;
}

.gift-record-item-date {
  line-height: 0.8rem;
}

.gift-record-item {
  width: 6.5rem;
  height: 0.8rem;
  font-size: 0.24rem;
  display: flex;
  /*color: #242424;*/
  justify-content: space-between;
  padding: 0 0.3rem;
  font-weight: 400;
}

.gift-record-item-name {
  display: flex;
  max-width: 3rem;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.gift-record-gift-name {
  display: inline-block;
  max-width: 3rem;
  white-space: nowrap;
  overflow: hidden;
  vertical-align: middle;
  text-overflow: ellipsis;
}

.gift-record-action-link {
  margin-left: 0.1rem;
  text-decoration: underline;
}


.gift-record-empty-status-area {
  width: 2.26rem;
  margin: 0 auto;
  margin-top: 1rem;
}

.gift-record-empty-status-img {
  width: 2.26rem;
  height: 1.8rem;
}

.gift-record-empty-status-text {
  margin-top: 0.1rem;
  /*color: #8e8e99;*/
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.32rem;
}
</style>
